import { FaCheck } from "react-icons/fa6";
import { SUCCESS_MESSAGES } from '../../constants/feedbackConstants';

const FeedbackSuccessScreen = ({ selectedOption, isVisible }) => {
  if (!selectedOption) return null;

  const successMessage = SUCCESS_MESSAGES[selectedOption.id];

  return (
    <div className={`fixed inset-0 z-[400000] bg-black bg-opacity-50 transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${
      isVisible ? 'opacity-100 visible' : 'opacity-0 invisible'
    }`}>
      <div className="flex flex-col items-center justify-center h-full p-8 text-center">
        {/* Success Icon */}
        <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mb-6 shadow-lg">
          <FaCheck className="w-10 h-10" />
        </div>

        {/* Success Title */}
        <h2 className="geomanistmedium text-[19px] font-bold text-white my-4 geomanistMedium">
          {successMessage.title}
        </h2>

        {/* Success Message */}
        <p className="text-white text-[15px] geomanistbold opacity-90 leading-relaxed w-[60%]">
          {successMessage.message}
        </p>
      </div>
    </div>
  );
};

export default FeedbackSuccessScreen; 